import { render, staticRenderFns } from "./UploadGPX.vue?vue&type=template&id=1584e4b0&scoped=true&"
import script from "./UploadGPX.vue?vue&type=script&lang=js&"
export * from "./UploadGPX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1584e4b0",
  null
  
)

export default component.exports